import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { useActions } from '../../../../hooks/useActions';
import { useReview } from '../../../../hooks/useReview';
import { useUser } from '../../../../hooks/useUser';
import { ReviewService } from '../../../../service/review.service';
import { ICommentChildrenResponse } from '../comment.interface';

export const useCommentItem = (comment: ICommentChildrenResponse) => {
  const { loggedIn } = useUser();
  const queryClient = useQueryClient();
  const [showItemCommentForm, setShowItemCommentForm] = useState(false);
  const [showItemComments, setShowItemComments] = useState(false);
  const { showComments, commentId, isLikeComment } = useReview();
  const {
    setCommentId,
    setShowComments,
    setIsLikeComment,
    setAuthVisible,
    setLikesCommentData,
    setCommentLikeId,
  } = useActions();
  /*  const { isLoading } = useQuery(['get comment', isLikeComment], () =>
    getComment({ review_comment_id: commentId })
  );*/
  const { mutateAsync } = useMutation(
    (likeOrDislike: boolean | null) =>
      ReviewService.setLikeOrDislike(comment.id, likeOrDislike),
    {
      onSuccess: ({ data }) => {
        setLikesCommentData(data.likes_info);
        /*queryClient.invalidateQueries(['get comments']);*/
      },
    }
  );
  const onSetLike = async () => {
    if (!loggedIn) return setAuthVisible(true);
    setCommentLikeId(comment.id);
    if (comment.is_like_by_me) {
      await mutateAsync(null);
    } else {
      await mutateAsync(true);
    }
  };

  const onSetDislike = async () => {
    if (!loggedIn) return setAuthVisible(true);
    setCommentLikeId(comment.id);
    if (comment.is_like_by_me === false) {
      await mutateAsync(null);
    } else if (comment.is_like_by_me || comment.is_like_by_me === null) {
      await mutateAsync(false);
    }
  };
  const onShowComments = async () => {
    setShowComments(!showComments);
  };
  const onShowCommentForm = () => {
    if (!loggedIn) return setAuthVisible(true);
    if (comment.id !== commentId) setCommentId(comment.id);
    setShowItemCommentForm(!showItemCommentForm);
  };

  return {
    commentItem: {
      showItemComments,
      showItemCommentForm,
    },
    action: {
      onShowComments,
      onSetDislike,
      onSetLike,
      setShowItemCommentForm,
      setShowItemComments,
      onShowCommentForm,
    },
  };
};
